export const EXPENSES_REASONS_QUERY_KEY = 'expensesReasons'
